import { gql } from 'graphql-tag'
import { ELEMENT_FIELDS, PAGE_INFO } from './catalogQuery'

export const REVIEWS = gql`
  query reviews(
    $where: ElementWhereInput
    $order: ElementOrderByInput
    $first: Int
    $after: String
  ) {
    elements(where: $where, order: $order, first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          name
          id
          bx_id
          detailText
          createdAt
          propertyValues {
            property {
              id
              code
              name
            }
            value
            id
          }
          propertyValuesRelation {
            id
            property {
              code
              name
              id
            }
            targetFiles {
              id
              url
              width
              height
              videoCover {
                id
                url
              }
            }
            targetElement {
              ...elementFields
            }
          }
        }
      }
    }
  }
  ${ELEMENT_FIELDS}
`

export const REVIEWS_FILES = gql`
  query reviewsFiles(
    $element: ElementWhereInput
    $after: FileWhereUniqueInput
  ) {
    files(
      first: 15
      after: $after
      where: {
        PropertyRelationTargetFiles: {
          some: {
            property: { code: { in: ["PHOTOS", "VIDEOS"] } }
            element: $element
          }
        }
      }
      orderBy: { createdAt: desc }
    ) {
      id
      url
      contentType
      videoCover {
        id
        url
      }
      PropertyRelationTargetFiles {
        element {
          id
          name
        }
      }
    }
  }
`

export const NEXT_REVIEW = gql`
  query nextReview(
    $id: String
    $where: ElementWhereInput
    $sortOrder: SortOrder
  ) {
    elements(
      where: $where
      order: { createdAt: $sortOrder }
      first: 3
      cursor: { id: $id }
    ) {
      nodes {
        id
      }
    }
  }
`

export const REVIEW_BY_ID = gql`
  query reviewById($id: String) {
    element(where: { id: { equals: $id } }) {
      id
      bx_id
      code
      name
      detailText
      createdAt
      active
      propertyValues {
        property {
          id
          code
          name
        }
        value
        id
      }
      propertyValuesRelation {
        property {
          code
        }
        targetFiles {
          id
          url
          width
          height
          videoCover {
            id
            url
          }
        }
        targetElement {
          ...elementFields
        }
      }
    }
  }
  ${ELEMENT_FIELDS}
`
